import React, { PropsWithChildren } from 'react';

import { H6 } from 'DesignLibrary/atoms';

export const BreakdownTag: React.FC<PropsWithChildren> = ({ children }) => <H6>{children}</H6>;
